import type { Entry } from '../entries/entry'
import type { CategoryTypeEnum } from './category.enum'

export class Category {
    categoryId: string
    companyId: string
    type: CategoryTypeEnum
    label: string
    createdAt: Date
    updatedAt: Date
    status: number
}
